import { RequestedAnswerItem } from "types/Models/chatQnA";
import { FileObject } from "types/Models/fileObject";
import { FilePreviewCell } from "./FilePreviewCell";
import { PreviousResponses } from "./PreviousResponses";

export const AnsweredQuestionCard = ({
  number,
  response,
}: {
  number: number;
  response: RequestedAnswerItem;
}) => (
  <div className="t-flex t-flex-col t-gap-2 t-rounded-md t-border t-border-solid t-border-neutral-10 t-p-3">
    <span className="t-flex t-items-center t-justify-center t-w-6 t-h-6 t-shrink-0 t-rounded-full t-text-body t-text-neutral-50 t-bg-surface-grey">
      {number}
    </span>

    <p className="t-m-0 t-text-body-sm t-text-text-30">{response.question}</p>

    <div className="t-flex t-flex-col t-gap-1.5 t-pl-2 t-border-0 t-border-l-2 t-border-solid t-border-neutral-20">
      {response.answer && (
        <p className="t-m-0 t-text-body-sm t-text-text-100">
          {response.answer}
        </p>
      )}
      {(response.documents ?? []).map((doc) => (
        <FilePreviewCell
          key={doc.uuid}
          file={{
            ...doc,
            uuid: doc.file_uuid,
            file_type: doc.file_type as FileObject["file_type"],
          }}
        />
      ))}
    </div>

    <PreviousResponses rounds={response.previous_rounds} />
  </div>
);
